import React from 'react';
import AuthExperience from './AuthExperience';

const Register = () => <AuthExperience defaultTab="register" />;

export default Register;